import React, {useState} from 'react';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { makeStyles } from "@material-ui/core/styles";
import { Link } from 'react-router-dom';
import ButtonBase from '../../../components/Buttons/ButtonBase';




const useStyles = makeStyles(theme => ({
    colorGrayIcon: {
        color: '#c1c1c1',
        padding: 0
      },
      TextField: {
        maxWidth: '336px',
        height: 74
      },
  }));



const SignInForm = (props) => {
    const {
        // dirty,
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        touched,
        errors,
        isValid,
        isLawyer,
        setFieldValue,
      } = props;
    const classes = useStyles();
    const [valuesPass, setValuesPass] = useState({
        showPassword: false,
      });


    const handleClickShowPassword = () => {
        setValuesPass({ ...valuesPass, showPassword: !valuesPass.showPassword });
      };

    return ( 
        <form style={{display:'flex',    
        flexDirection: 'column', width: '100%',
        alignItems: 'center'}}>

        
       
        <TextField
            label="Correo"
            type="email"
            id="email"
            variant="outlined"
            classes={{ root: classes.TextField }}
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.email}
            helperText={touched.email && errors.email ? errors.email : ''}
            error={touched.email && errors.email ? true : false}
        />



        <TextField
            id="outlined-adornment-password"
            variant="outlined"
            type={valuesPass.showPassword ? 'text' : 'password'}
            label="Contraseña"
            name="password"
            classes={{ root: classes.TextField }}
            value={values.password}
            onBlur={handleBlur}
            onChange={handleChange}
            helperText={
            touched.password && errors.password ? errors.password : ''
            }
            error={touched.password && errors.password ? true : false}
            InputProps={{
            endAdornment: (
                <InputAdornment position="end">
                <IconButton
                    aria-label="Toggle password visibility"
                    onClick={handleClickShowPassword}
                    classes={{
                    root: classes.colorGrayIcon
                    }}
                >
                    {valuesPass.showPassword ? (
                    <VisibilityOff />
                    ) : (
                    <Visibility />
                    )}
                </IconButton>
                </InputAdornment>
            )
            }}
        />


                    <div className="container-forget-password">
                        <Link className="text-forget-password" to={'/usuario/restablecer-password'}>
                        <p className="text-forget-password">
                            ¿Olvidaste tu contraseña?
                        </p>
                        </Link>
                    </div>
                    
               

                <div className="horizontal-layout" style={{ marginTop: 32 }}>
                    <ButtonBase
                    type="submit"
                    onClick={handleSubmit}
                    variant="primary"
                    disabled={!isValid}
                    >
                    Ingresar
                    </ButtonBase>
                </div>
                
        

        
    </form>
     );
}
 
export default SignInForm;


